import { DeleteDocumentResponse } from '@eigtech/documents-types'
import { ensureDocumentCorn } from '@eigtech/documents-util'
import { Corn } from '@eigtech/shared-corn'
import { contextualRemove, useMutation } from '@eigtech/ui-shared-api'
import { documentsBasePath } from './constants'
import { useInvalidateEntityDocuments } from './getEntityDocuments'

export type DeleteDocumentRequest = { entityId: Corn; documentId: string }

function deleteDocument({ documentId, entityId }: DeleteDocumentRequest) {
  const documentCorn = ensureDocumentCorn(documentId)

  return contextualRemove<DeleteDocumentResponse>(
    `${documentsBasePath}/${entityId}/${documentCorn}`,
    null,
    { responseType: 'none' }
  )
}

export function useDeleteDocument() {
  const invalidateDocuments = useInvalidateEntityDocuments()

  return useMutation({
    mutationFn: deleteDocument,
    onSuccess(__, req) {
      invalidateDocuments(req.entityId)
    },
  })
}
